import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageLogin from './pages/Login'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import formErros from './modules/formErros'
import swiperCasesSucesso from './modules/swiperCasesSucesso'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'
import formContato from './modules/faleConosco'
import formCurso from './modules/formCurso'
import shareUrl from './modules/sharedURL'
import animaTestemunials from './modules/animaTestemunials'

// Init
GLOBAL.DesignSystem = DesignSystem({})
register() // Swiper Web Component

const pageHome = document.querySelector('.Home')
const pageCases = document.querySelector('.Cases')
const pageBlog = document.querySelector('.Blog')

// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()
animaAoScroll()
formContato()
formCurso()
swiperCasesSucesso()

if(pageHome || pageBlog || pageCases){
		animaTestemunials()
}

PageLogin()?.init()

// utils logs
logs()

shareUrl()


 var swiperCertificacoesQsms = new Swiper(".swiper-certificacoes-qsms", {
		slidesPerView: 2,
 		watchOverflow: true,
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
		},
		navigation: {
			nextEl: ".swiper-button-next-qsms",
			prevEl: ".swiper-button-prev-qsms",
		},

		breakpoints: {
        0: {
            slidesPerView: "auto",
        },
        1024: {
            slidesPerView: 2,
						spaceBetween:32
        },
    },
});